export default __webpack_public_path__ + "static/media/NoInvoiceGraphic.c8d95458.png";